import { ProductListAnalyticsService } from '@analytics/feature';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { ProductWishlistService } from '@wishlist/feature';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'sd-product-wishlist-button',
  templateUrl: './product-wishlist-button.component.html',
  styleUrls: ['./product-wishlist-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent, AsyncPipe],
})
export class SdvorProductWishlistButtonComponent implements OnInit {
  private readonly productWishlistService = inject(ProductWishlistService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly productListAnalyticsService = inject(ProductListAnalyticsService, { optional: true });

  @Input() productCode: string;
  hasEntry$ = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean>;

  ngOnInit(): void {
    this.productWishlistService
      .hasEntry(this.productCode)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((hasEntry) => this.hasEntry$.next(hasEntry));
    this.loading$ = this.productWishlistService.getEntryLoading(this.productCode);
  }

  addOrRemoveEntry(): void {
    const currentValue = this.hasEntry$.value;
    this.hasEntry$.next(!currentValue);

    const listName = this.productListAnalyticsService?.getListName() || '';

    this.productWishlistService.addOrRemoveEntry(this.productCode, listName);
  }
}
